import { LightbulbFilament } from '@phosphor-icons/react'
import { Icon } from '@shopflo/ui'
import React from 'react'

interface DiscountInfoTextProps {
  text: string
  show?: boolean
}

const DiscountInfoText = ({ text, show = true }: DiscountInfoTextProps) => {
  if (!show) return null

  return (
    <div className='flex gap-1 items-center '>
      <Icon IconComponent={LightbulbFilament} size='xs' className='text-sky-600' iconProps={{ weight: 'duotone' }} />
      <p className='text-text-xs-medium text-sky-600 '>{text}</p>
    </div>
  )
}

export default DiscountInfoText
